import '../modules/uPopup';
import {cookie} from '../modules/cookie';
import {raskhlop} from '../modules/raskhlop';


var bbutton = function(el){
    var param = JSON.parse(el.getAttribute('data-param')),
        closeBtn = el.querySelector('[data-bbutton-close]'),
        lookBtn = el.querySelector('[data-bbutton-look]'),
        goBtnAll = el.querySelectorAll('[data-bbutton-go]'),
        raskhlopObj,
        setCookie = function(expires){
            var options = {},
                domains = ['.kinoafisha.spb.ru', '.kinoafisha.msk.ru', '.kinoafisha.info'],
                i = 0,
                l = domains.length;

            options.expires = expires;
            options.path = '/';

            for(i; i<l; i++){
                options.domain = domains[i];
                cookie.setCookie('branding_bbutton', '1', options);
            }
        },
        addPixel = function(){
            for(var i= 0,j=param.px.length; i<j; i++){
                var img = document.createElement('IMG'),
                    src = param.px[i];

                img.setAttribute('class', 'px');
                img.setAttribute('src', src + '&rnd=' + new Date().getTime());
                document.body.appendChild(img);
            }
        },
    /* Просто перенес функцию с мобильной версии */
        mobileRaskhlop = function(){
            var box = document.getElementById('branding'),
                param = JSON.parse(box.getAttribute('data-param')),
                close = box.querySelector('[data-close]'),
                addPixel = function(){
                    for(var i= 0,j=param.px.length; i<j; i++){
                        var img = document.createElement('IMG'),
                            src = param.px[i];

                        img.setAttribute('class', 'px');
                        img.setAttribute('src', src + '&rnd=' + new Date().getTime());
                        document.body.appendChild(img);
                    }
                };

            //
            param.px = typeof param.px === 'string' ? [param.px] : param.px;

            document.body.className = document.body.className + ' tobuy';
            close.onclick = function(){
                //document.body.removeChild(box);
                document.body.className = document.body.className.replace(' tobuy', '');
            }

            addPixel();
        },

        onLookClick = function(e){
            e.preventDefault();

            onCloseClick();

            if(APP.vars.isMobile){
                mobileRaskhlop();
            } else {
                var el = document.querySelector('[data-bbutton-raskhlop]'),
                    obj = raskhlop(el);

                //
                obj.start();
            }
        },
        onGoClick = function(){
            onCloseClick();
        },
        onCloseClick = function(e){
            if(e) e.preventDefault();

            el.classList.remove('js-active');
            setCookie(3600*24);
        },
        start = function(){
            if(lookBtn) lookBtn.addEventListener('click', onLookClick);
            Array.prototype.forEach.call(goBtnAll, function(goBtn){
                goBtn.addEventListener('click', onGoClick);
            });
            closeBtn.addEventListener('click', onCloseClick);
            el.classList.add('js-active');
            addPixel();
        };

    //
    if (!navigator.cookieEnabled) return false;
    if (window.location.hostname.indexOf('kinoafishaspb.ru') !== -1) return false; /* на деве не показываем кнопку */

    param.px = typeof param.px === 'string' ? [param.px] : param.px;

    if(!cookie.getCookie('branding_bbutton') || window.location.pathname.indexOf('/_src/') !== -1){
        if (document.readyState === "complete") {
            start();
        } else {
            window.addEventListener('load', start);
        }
    }
}

export {bbutton};


